import PaymentForm from '../components/PaymentForm';
import { Box, Typography } from '@mui/material';

// top Half screen orange background
const TopHalfScreen = () => {
    return (
        <Box sx={{ 
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: -1,
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            padding: '2rem'
        }}>
            <Typography variant="h3"
            sx={{
                fontWeight: 'bold',
                color: '#030303',
                textAlign: 'center',
                marginTop: '2rem',
                paddingTop: '64px'
            }}
            >
                Elija un medio de pago para abonar la suscripción
            </Typography>
        </Box>
    );
};

const PaymentPage = () => {
    return (
        <Box>
            <TopHalfScreen />
                <PaymentForm />
        </Box>
    );
};

export default PaymentPage;